import { onMounted, ref } from 'vue'

import { parseJSON, stringifyJSON } from '@/features/utils/json.utils.js'

export function useWelcomeToClub() {
  const isVisible = ref(false)

  function setWelcomeToClubVisible() {
    isVisible.value = true
    localStorage.setItem('welcomeToClub', stringifyJSON(true))
  }

  function getWelcomeToClubValue() {
    const storedValue = localStorage.getItem('welcomeToClub')
    if (storedValue === null) return false
    return parseJSON(storedValue) === true
  }

  function closeWelcomeToClub() {
    localStorage.removeItem('welcomeToClub')
    isVisible.value = false
  }

  onMounted(() => {
    isVisible.value = getWelcomeToClubValue()
  })

  return {
    isVisible,
    setWelcomeToClubVisible,
    closeWelcomeToClub,
  }
}
